import React from "react";
import R from "ramda";
import styled from "styled-components";
import { compose, lifecycle, withState, withHandlers, pure, withPropsOnChange, } from "recompose";
import { connect, } from "react-redux";
import * as contentful from "contentful-management";

import * as m from "src/components/style/mixins";
import * as v from "src/components/style/vars";
import * as consts from "src/consts";
import { plog, } from "src/lib/util";

import {
	GridCell,
	Button,
	ContainedImage,
	logProps,
	TextInput as BaseTextInput,
	TextArea as BaseTextArea,
	getTagArray,
	getTagString,
} from "src/components/common";

// --------------------------------------------------

export const Box = styled.div`
	width: 100%;
	background-color: white;
	${m.shadow(1)}
	font-size: 0.9em;
	padding: 1em;
`;

export const FormGroup = styled.div`
	margin-bottom: 0.5em;

	&:last-child {
		margin-bottom: 0;
	}
`;

export const Label = styled.div`
	font-size: 0.9em;
	font-weight: bold;
	text-transform: uppercase;
	line-height: 1;
	margin-bottom: 0.5em;
`;

const inputPadding = 0.5;

export const TextInput = props => <BaseTextInput { ...props } padding = { inputPadding }/>
export const TextArea = props => <BaseTextArea { ...props } padding = { inputPadding }/>

// --------------------------------------------------

const enhance = compose(
	pure,
	connect(R.identity),
	withHandlers({
		setContent: ({ setEntry, entry, }) => ({ content, fieldName, }) => {
			setEntry({
				...entry,
				fields: {
					...entry.fields,
					[fieldName]: {
						[consts.lang]: content,
					}
				},				
			});
		},
	}),
	withHandlers({
		setImage: ({ setContent, }) => () => {},
		setTitle : ({ setContent, }) => e => {
			setContent({
				content: e.target.value,
				fieldName: "title",
			});
		},
		setDescription: ({ setContent, }) => e => {
			setContent({
				content: e.target.value,
				fieldName: "description",
			});
		},
		setTags: ({ setContent, }) => e => {
			setContent({
				content: getTagArray(e.target.value),
				fieldName: "tags",
			});
		},
	}),
	withPropsOnChange([ "entry", ], ({ entry, }) => (
		R.map(R.prop(consts.lang))(entry.fields)
	)),
	withState("imageSrc", "setImageSrc", ""),
	withPropsOnChange([ "image", ], ({ image, setImageSrc, space, }) => {
		space.getAsset(image.sys.id)
		.then(R.path([ "fields", "file", consts.lang, "url", ]))
		.then(setImageSrc);
	}),
	withPropsOnChange([ "tags", ], R.pipe(
		R.prop("tags"),
		getTagString,
		R.objOf("tagString"),
	)),
);

const Comp = ({
	entry,
	setEntry,
	title,
	setTitle,
	imageSrc,
	description,
	setDescription,
	tagString,
	setTags,
}) => (
	<Box>
		<GridCell>
			<FormGroup>
				<ContainedImage src = { imageSrc } bg = "black" height = "75%" />
			</FormGroup>

			<FormGroup>
				<Label>Title</Label>
				<TextInput name = "title" value = { title } onChange = { setTitle }/>
			</FormGroup>

			<FormGroup>
				<Label>Tags</Label>
				<TextInput name = "tags" value = { tagString } onChange = { setTags }/>
			</FormGroup>

			<FormGroup>
				<Label>Description</Label>
				<TextArea name = "description" value = { description } onChange = { setDescription } lines = { 3 }/>
			</FormGroup>
		</GridCell>		
	</Box>
);

export default enhance(Comp);



// WEBPACK FOOTER //
// ./src/components/Editor/Images/GalleryImage.js